import {Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef} from '@angular/core';

import {Account} from '../../models/account';
import {AccountService} from '../../services/account.service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ToastsManager} from 'ng2-toastr';
import { TranslateService } from '@ngx-translate/core';

/**
 * Modal dialog asking confirmation to user for account deleting
 */
@Component({
  selector: 'app-account-delete',
  templateUrl: './account-delete.component.html',
  styleUrls: ['./account-delete.component.css']
})
export class AccountDeleteComponent implements OnInit {

  account: Account;

  @Output() onDeleteValidation = new EventEmitter<boolean>();

  constructor(private accountService: AccountService,
              public activeModal: NgbActiveModal,
              public toastsManager: ToastsManager,
              public translate : TranslateService) {
  }

  ngOnInit() {
  }

  onDeleteClick() {
    this.activeModal.close(null);
    this.accountService.delete(this.account).subscribe(() => {
      this.toastsManager.success(this.translate.instant("toast.userdeleted"));
      this.onDeleteValidation.emit(true);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/accounts/account-delete/account-delete.component.ts